export const SET_DAY = "app/Roster/SET_DAY";
export const SET_WEEK = "app/Roster/SET_WEEK";
export const SET_WEEK_RANGE = "app/Roster/SET_WEEK_RANGE";
export const SET_ROSTER = "app/Roster/SET_ROSTER";
export const SET_DRAG_CELL = "app/Roster/SET_DRAG_CELL"; // cell being dragged
export const TOGGLE_CALENDER = "app/Roster/TOGGLE_CALENDER";
export const SET_DRAG_SHIFT = "app/Roster/SET_DRAG_SHIFT";
export const TOGGLE_DELETE = "app/Roster/TOGGLE_DELETE";
export const SET_SHIFT = "app/Roster/SET_SHIFT";
export const TOGGLE_BULK_CONFIRM = "app/Roster/TOGGLE_BULK_CONFIRM";
export const TOGGLE_VIEW = "app/Roster/TOGGLE_VIEW";
export const SET_SELECTED = "app/Roster/SET_SELECTED";
export const TOGGLE_CLOCK_MODAL = "app/Roster/TOGGLE_CLOCK_MODAL";
export const TOGGLE_APPROVE_MODAL = "app/Roster/TOGGLE_APPROVE_MODAL";
export const TOGGLE_DROP_MODAL = "app/Roster/TOGGLE_DROP_MODAL";
export const TOGGLE_REQ_MODAL = "app/Roster/TOGGLE_REQ_MODAL";
export const TOGGLE_SUMMARY_MODAL = "app/Roster/TOGGLE_SUMMARY_MODAL";
export const TOGGLE_COPY = "app/Roster/TOGGLE_COPY";
export const TOGGLE_UPDATE = "app/Roster/TOGGLE_UPDATE";
export const TOGGLE_AVAIL_MODAL = "app/Roster/TOGGLE_AVAIL_MODAL";
export const TOGGLE_CLOCKADD_MODAL = "app/Roster/TOGGLE_CLOCKADD_MODAL";
export const SET_ROTA_EMP = "app/Roster/SET_ROTA_EMP";
export const SET_ROTA_EMP_NAME = "app/Roster/SET_ROTA_EMP_NAME";

export const GET_SETTINGS = "app/Roster/GET_SETTINGS";
export const GET_SETTINGS_SUCCESS = "app/Roster/GET_SETTINGS_SUCCESS";
export const GET_SETTINGS_FAILURE = "app/Roster/GET_SETTINGS_FAILURE";

export const SAVE_SETTINGS = "app/Roster/SAVE_SETTINGS";
export const SAVE_SETTINGS_SUCCESS = "app/Roster/SAVE_SETTINGS_SUCCESS";
export const SAVE_SETTINGS_FAILURE = "app/Roster/SAVE_SETTINGS_FAILURE";

export const CLOCK_IN = "app/Roster/CLOCK_IN";
export const CLOCK_IN_SUCCESS = "app/Roster/CLOCK_IN_SUCCESS";
export const CLOCK_IN_FAILURE = "app/Roster/CLOCK_IN_FAILURE";

export const UPDATE_CLOCKIN = "app/Roster/UPDATE_CLOCKIN";
export const UPDATE_CLOCKIN_SUCCESS = "app/Roster/UPDATE_CLOCKIN_SUCCESS";
export const UPDATE_CLOCKIN_FAILURE = "app/Roster/UPDATE_CLOCKIN_FAILURE";

export const APPROVE_DROP = "app/Roster/APPROVE_DROP";
export const APPROVE_DROP_SUCCESS = "app/Roster/APPROVE_DROP_SUCCESS";
export const APPROVE_DROP_FAILURE = "app/Roster/APPROVE_DROP_FAILURE";

export const REJECT_DROP = "app/Roster/REJECT_DROP";
export const REJECT_DROP_SUCCESS = "app/Roster/REJECT_DROP_SUCCESS";
export const REJECT_DROP_FAILURE = "app/Roster/REJECT_DROP_FAILURE";

export const UPDATE_REQUEST = "app/Roster/UPDATE_REQUEST";
export const UPDATE_REQUEST_SUCCESS = "app/Roster/UPDATE_REQUEST_SUCCESS";
export const UPDATE_REQUEST_FAILURE = "app/Roster/UPDATE_REQUEST_FAILURE";

export const APPROVE_SWAP = "app/Roster/APPROVE_SWAP";
export const APPROVE_SWAP_SUCCESS = "app/Roster/APPROVE_SWAP_SUCCESS";
export const APPROVE_SWAP_FAILURE = "app/Roster/APPROVE_SWAP_FAILURE";

export const REJECT_SWAP = "app/Roster/REJECT_SWAP";
export const REJECT_SWAP_SUCCESS = "app/Roster/REJECT_SWAP_SUCCESS";
export const REJECT_SWAP_FAILURE = "app/Roster/REJECT_SWAP_FAILURE";

export const COPY_ROSTER = "app/Roster/COPY_ROSTER";
export const COPY_ROSTER_SUCCESS = "app/Roster/COPY_ROSTER_SUCCESS";
export const COPY_ROSTER_FAILURE = "app/Roster/COPY_ROSTER_FAILURE";
export const SET_COPY_DATA = "app/Roster/SET_COPY_DATA";

export const ADD_CLOCK = "app/Roster/ADD_CLOCK";
export const ADD_CLOCK_SUCCESS = "app/Roster/ADD_CLOCK_SUCCESS";
export const ADD_CLOCK_FAILURE = "app/Roster/ADD_CLOCK_FAILURE";

export const GET_PAID_HOURS = "app/Roster/GET_PAID_HOURS";
export const GET_PAID_HOURS_SUCCESS = "app/Roster/GET_PAID_HOURS_SUCCESS";
export const GET_PAID_HOURS_FAILURE = "app/Roster/GET_PAID_HOURS_FAILURE";

export const GET_SETTINGS_HISTORY = "app/Roster/GET_SETTINGS_HISTORY";
export const GET_SETTINGS_HISTORY_SUCCESS =
  "app/Roster/GET_SETTINGS_HISTORY_SUCCESS";
export const GET_SETTINGS_HISTORY_FAILURE =
  "app/Roster/GET_SETTINGS_HISTORY_FAILURE";

export const TOGGLE_HISTORY_MODAL = "app/Roster/TOGGLE_HISTORY_MODAL";

export const CLAIM_SHIFT = "app/Roster/CLAIM_SHIFT";
export const CLAIM_SHIFT_SUCCESS = "app/Roster/CLAIM_SHIFT_SUCCESS";
export const CLAIM_SHIFT_FAILURE = "app/Roster/CLAIM_SHIFT_FAILURE";

export const GET_LOC_SETTINGS = "app/Roster/GET_LOC_SETTINGS";
export const GET_LOC_SETTINGS_SUCCESS = "app/Roster/GET_LOC_SETTINGS_SUCCESS";
export const GET_LOC_SETTINGS_FAILURE = "app/Roster/GET_LOC_SETTINGS_FAILURE";

export const SAVE_LOC_SETTINGS = "app/Roster/SAVE_LOC_SETTINGS";
export const SAVE_LOC_SETTINGS_SUCCESS = "app/Roster/SAVE_LOC_SETTINGS_SUCCESS";
export const SAVE_LOC_SETTINGS_FAILURE = "app/Roster/SAVE_LOC_SETTINGS_FAILURE";
